import {ChangeDetectionStrategy, Component, HostBinding} from '@angular/core';
import {Skeleton} from "primeng/skeleton";

@Component({
  selector: 'homey-lottery-list-item-skeleton',
  imports: [
    Skeleton
  ],
  templateUrl: './lottery-list-item-skeleton.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class LotteryListItemSkeletonComponent {
  @HostBinding('class') readonly hostClass = 'flex items-center gap-2 relative';

}
